<template>
    <span class="play-outline-icon">
        <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            :stroke="stroke"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
        >
            <polygon points="6 3 20 12 6 21 6 3" />
        </svg>
    </span>
</template>

<script>
export default {
    name: 'IconPlayOutline',
    props: {
        stroke: {
            type: String,
            default: 'currentColor',
        },
    },
};
</script>

<style scoped>
/* A plain <span> as a flex/grid item gets blockified but doesn't itself
   center its inline-level svg content — the svg ends up flush to the
   span's top edge instead of vertically centered. Making the wrapper a
   flex container itself fixes this for every consumer, regardless of how
   the surrounding button centers its children. */
.play-outline-icon {
    display: inline-flex;
    align-items: center;
}
</style>
